import { useQuery, useQueryClient } from 'react-query';

import { CACHE_KEYS } from './config';
import * as CampaignResultAPI from './CampaignResultAPI';
import * as TapSurveyAPI from './TapSurveyAPI';

const TWO_MINUTES = 1000 * 60 * 2;
const TEN_SECONDS = 1000 * 10;

export const useResultsData = (isCampaignResult, identifier) => {
  const queryClient = useQueryClient();
  const { isInitialResultsLoad } =
    queryClient.getQueryData([
      CACHE_KEYS.RESULTS,
      isCampaignResult,
      identifier,
    ]) || {};

  return useQuery(
    [CACHE_KEYS.RESULTS, isCampaignResult, identifier],
    async () => {
      const result = isCampaignResult
        ? await CampaignResultAPI.getResultsData(identifier)
        : await TapSurveyAPI.getResultsData(identifier);

      const zeroCompletes =
        result && result.fielding && result.fielding.completes_count === 0;
      const hasResult =
        result &&
        result.fielding &&
        result.fielding.completes_count !== undefined;

      return {
        ...result,
        isInitialResultsLoad:
          (isInitialResultsLoad && !hasResult) || zeroCompletes,
      };
    },
    {
      enabled: !!identifier,
      staleTime: isInitialResultsLoad ? 0 : TWO_MINUTES,
      refetchInterval: isInitialResultsLoad ? TEN_SECONDS : TWO_MINUTES,
    }
  );
};

export const useCrossTabData = (
  isCampaignResult,
  identifier,
  primary_question_id,
  secondary_question_id
) =>
  useQuery(
    [
      CACHE_KEYS.RESULTS,
      isCampaignResult,
      identifier,
      primary_question_id,
      secondary_question_id,
    ],
    () =>
      isCampaignResult
        ? CampaignResultAPI.getCrossTabData(
            identifier,
            primary_question_id,
            secondary_question_id
          )
        : TapSurveyAPI.getCrossTabData(
            identifier,
            primary_question_id,
            secondary_question_id
          ),
    {
      enabled: !!identifier && !!primary_question_id && !!secondary_question_id,
      staleTime: TWO_MINUTES,
      refetchInterval: TWO_MINUTES,
    }
  );
